import {useEffect, useCallback} from 'react'
import {useDispatch} from 'redux-react-hook'
import {MainSDK} from 'services/callApi'
import {entities as entitiesAct} from 'actions'

export default function useGetUserAssetProvider (asset) {
  const dispatch = useDispatch()
  const fetchData = useCallback(async () => {
    const userAsset = await MainSDK.exchange.getUserAsset(asset)
    if (userAsset) dispatch(entitiesAct({userAsset}))
  }, [asset, dispatch])

  useEffect(() => {
    fetchData()
  }, [dispatch, fetchData])
}
